import ChartJS from "chart.js/auto"
import { ArcElement, Legend, Tooltip } from "chart.js"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import axios from "axios"
import { Pie } from "react-chartjs-2"
import { getAux } from "../../../store/features/auxSlice"
import { getConf } from "../../../store/features/confSlice"
import { Button, Grid } from "@mui/material"
import saveAs from "file-saver"
import { getAuth } from "../../../store/features/authSlice"

/**
 * Tipo: Pie
 * Detalle: Muestra la cantidad de usuarios por cada rol
 */

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env
ChartJS.register(ArcElement, Tooltip, Legend)

export const UsersForRoleChart = () => {
  const conf = useSelector(getConf)
  const aux = useSelector(getAux)
  const auth = useSelector(getAuth)
  const [report, setReport] = useState([])
  const [isLoading, setLoading] = useState(true)
  const title = "Usuarios por rol"

  useEffect(() => {
    getReport()
  }, [])

  const getReport = async () => {
    try {
      const endpoint = `/report/chart/users-for-role`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReport(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      console.log("No se pudo obtener los datos del reporte")
    }
  }

  const download = () => {
    const head = "id de rol;rol;usuarios\n"
    const body = report
      .map((item) => {
        const roleId = item.role
        const role = aux.data.roles.find((e) => e.id === roleId).value
        const users = item.users
        return roleId + ";" + role + ";" + users
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  if (isLoading) return <></>

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: title,
      },
    },
  }

  const data = {
    labels: report.map(
      (item) => aux.data.roles.find((e) => e.id === item.role).value
    ),
    datasets: [
      {
        label: "Cantidad de usuarios",
        data: report.map((item) => item.users),
        backgroundColor: conf.data.colors
          .filter((_, index) => index > 0)
          .map((item) => item.bg),
        borderWidth: 1,
      },
    ],
  }

  return (
    <>
      <Pie options={options} data={data} />
      <Grid container spacing={1} my={1}>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ height: 55 }}
            onClick={download}
          >
            Descargar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
